import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
let _ = t => t,
  _t;
const _excluded = ["children"];
import styled, { mediaQuery, css, academyPageFullWidth, academyResultsBar } from 'academy-common-lib/utils/Styling';
import Heading from '../../../components/Layouts/Heading';
import { EditPlaylistButton } from './EditPlaylistButton';
import { usePlaylist } from '../savedItemsQueries';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../constants/Navigation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BackButton } from '../../navigation';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useIsHubspotPlaylist } from '../savedItemsHooks';
import styledWithTheme from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const Subheader = styled(_ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("nav", Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      justify: "between",
      children: children
    })
  }));
}).withConfig({
  displayName: "PlaylistPageHeader__Subheader",
  componentId: "sc-1drpepf-0"
})(["", " & > div{height:100%;", ";}padding-right:12px;padding-left:12px;", ";"], academyResultsBar, academyPageFullWidth, mediaQuery('notMobile', css(["padding-right:12px;padding-left:24px;"])));
export const PlaylistBackButton = styledWithTheme(BackButton)(_t || (_t = _`
  ${0}

  ${0}
`), mediaQuery('mobile', css(["color:", " !important;"], ({
  theme: trellisTheme
}) => trellisTheme.color['text-interactive-default'])), mediaQuery('notMobile', css(["color:", " !important;"], ({
  theme: trellisTheme
}) => trellisTheme.color['text-core-on-fill-default'])));
export const PlaylistPageHeader = ({
  playlistId
}) => {
  const {
    playlist
  } = usePlaylist(Number(playlistId));
  const isHubspotPlaylist = useIsHubspotPlaylist(playlist === null || playlist === void 0 ? void 0 : playlist.id);
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, {
      subtitle: isHubspotPlaylist ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.hubspotPlaylist"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.playlist"
      }),
      title: playlist ? playlist.name : ''
    }), isMobile && /*#__PURE__*/_jsxs(Subheader, {
      children: [/*#__PURE__*/_jsx(PlaylistBackButton, {
        exact: true,
        to: MY_PLAYLISTS_URL_FRAGMENT,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.playlists.myPlaylists"
        })
      }), /*#__PURE__*/_jsx(EditPlaylistButton, {
        $isHiddenFor: "notMobile",
        block: false,
        playlistId: playlistId,
        responsive: false
      })]
    })]
  });
};